"use strict";
export const initHomeBannerGsap = async (selector) => {
    const element = document.querySelector(selector);
    if (!element) return;
	try {
        const module = await import('../modules/home-banner');
        module.initHomeBannerGsap(selector);
	} catch (error) {
		console.error("Failed to load Home Banner Animation dynamically:", error);
		return;
	}
}